import { Adapter } from '@tronweb3/tronwallet-abstract-adapter';
import {
  BinanceWalletAdapter,
  BybitWalletAdapter,
  LedgerAdapter,
  OkxWalletAdapter,
  TokenPocketAdapter,
  TronLinkAdapter,
  TrustAdapter,
} from '@tronweb3/tronwallet-adapters';
import { atom } from 'jotai';
import { APP_LOGO_URL, APP_NAME } from '@/lib/constants';

export const tronLinkAdapterAtom = atom(
  new TronLinkAdapter({
    dappIcon: APP_LOGO_URL,
    dappName: APP_NAME,
  }),
);
export const tronTrustAdapterAtom = atom(new TrustAdapter());
export const tronTokenPocketAdapterAtom = atom(new TokenPocketAdapter());
export const tronLedgerAdapterAtom = atom(new LedgerAdapter());
export const tronOkxWalletAdapterAtom = atom(new OkxWalletAdapter());
export const tronBybitWalletAdapterAtom = atom(new BybitWalletAdapter());
export const tronBinanceWalletAdapterAtom = atom(new BinanceWalletAdapter());

export const tronAdaptersAtom = atom<Adapter[]>((get) => [
  get(tronLinkAdapterAtom),
  get(tronTrustAdapterAtom),
  get(tronTokenPocketAdapterAtom),
  get(tronLedgerAdapterAtom),
  get(tronOkxWalletAdapterAtom),
  get(tronBybitWalletAdapterAtom),
  get(tronBinanceWalletAdapterAtom),
]);
